import React, { Fragment, useState, useEffect } from "react";
import { Switch } from "@headlessui/react";

type Args = { onChange: any; initialValue: boolean };

export default function ToggleButton({ onChange, initialValue }: Args) {
  const [enabled, setEnabled] = useState<boolean>(initialValue);

  function handleChange() {
    setEnabled(!enabled);
  }

  useEffect(() => {
    onChange(enabled);
  }, [enabled]);

  return (
    <Fragment>
      <div className="">
        <Switch.Group as="div" className="flex items-center space-x-4">
          <Switch
            as="button"
            checked={enabled}
            onChange={handleChange}
            className={`${
              enabled ? "bg-green-400" : "bg-gray-200"
            } relative inline-flex flex-shring-0 h-6 w-12 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer focus:outline-none focus:shadow-outline `}
          >
            {({ checked }) => (
              <span
                className={` ${
                  checked ? "translate-x-6" : "translate-x-0"
                } inline-block w-5 h-5 transition duration-200 ease-in-out transform bg-white rounded-full`}
              ></span>
            )}
          </Switch>
          <Switch.Label as="label" className="text-sm font-medium text-black">
            Display in fiat
          </Switch.Label>
        </Switch.Group>
      </div>
    </Fragment>
  );
}
